import { createBaseThemeVariation } from './base';
export const BusybeesTheme = createBaseThemeVariation({
    name: 'busybees',
    brandColor: 'hsla(353, 78%, 55%, 1)',
});
